<div class="px-4 sm:px-6 lg:px-8 flex flex-col space-y-4">
  <div class="sm:flex sm:items-center">
    <div class="sm:flex-auto">
      <h1 class="font-semibold leading-6 text-gray-900 !text-3xl">Changelog</h1>
    </div>
  </div>
  <div *ngIf="PermissionService.CheckPermission(PermissionService.Owner())"
       class="flex flex-col bg-white shadow-2xl px-4 py-2 rounded-lg space-y-2 w-full">
    <div class="flex flex-col md:flex-row w-full space-x-3">
      <div class="flex w-full place-self-center">
        <label class="sr-only" for="title"></label>
        <input [(ngModel)]="editorTitle" class="w-full text-2xl border-2 px-1.5 place-self-center" id="title" name="title"
               placeholder="Title"/>
      </div>
      <div *ngIf="editingItem" class="flex">
        <input (ngModelChange)="setDate($event)" [ngModel]="TimeUtilities.dateToString(editingItem.created)"
               class="place-self-center" type="datetime-local">
      </div>
    </div>
    <ejs-richtexteditor #changelogRTE (created)="onCreate()" (valueChange)="fixHtmlReplacement()"
                        [(value)]="editorContent" [enableHtmlSanitizer]="false" [enableResize]="true" [formatter]="formatter"
                        [toolbarSettings]="tools" editorMode="Markdown" id='changelogRTE'>
      <ng-template #valueTemplate>
        #
      </ng-template>
    </ejs-richtexteditor>
    <div *ngIf="!editingItem" class="inline-flex w-full space-x-4">
      <span (click)="clearEdit()"
            class="text-gray-600 hover:text-gray-800 cursor-pointer select-none ml-auto place-self-center">Clear</span>
      <button
        (click)="post()"
        class="rounded-md bg-theme-primary-700 hover:text-theme-primary-900 text-white cursor-pointer select-none py-1 px-3 place-self-center">Save
      </button>
    </div>
    <div *ngIf="editingItem" class="inline-flex w-full space-x-4">
      <span (click)="deleteEdit()"
            *ngIf="editingItem.active" class="text-red-600 hover:text-red-800 cursor-pointer select-none place-self-center mr-auto">Deactivate</span>
      <span (click)="reactivateEdit()"
            *ngIf="!editingItem.active" class="text-green-700 hover:text-green-800 cursor-pointer select-none place-self-center mr-auto">Reactivate</span>
      <span (click)="clearEdit()"
            class="text-gray-600 hover:text-gray-800 cursor-pointer select-none ml-auto place-self-center">Cancel</span>
      <button
        (click)="update(editingItem.id, editorTitle, editorContent, editingItemNewDate)"
        class="rounded-md bg-theme-primary-700 hover:text-theme-primary-900 text-white cursor-pointer select-none py-1 px-3 place-self-center">Update
      </button>
    </div>
  </div>
  <div class="bg-white rounded-lg shadow-2xl flex flex-col p-4 space-y-8">
    <div *ngFor="let item of changelogFiltered;let index = index"
         [class.border-b-2]="changelogFiltered && changelogFiltered.length > index + 1" [class.opacity-50]="!item.active"
         class="w-full space-y-3 text-xl font-light border-gray-500 pb-4">
      <div class="w-full inline-flex">
        <h1 class="place-self-center">
          <span *ngIf="!item.active" class="text-red-700">[Inactive]</span>
          {{ item.name }}
        </h1>
        <div (click)="edit(item)"
             *ngIf="PermissionService.CheckPermission(PermissionService.Owner())"
             class="ml-auto place-self-center text-theme-primary-700 hover:text-theme-primary-900 select-none cursor-pointer">
          <svg class="bi bi-pencil-square" height="24" viewBox="0 0 16 16" width="24"
               xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
            <path d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                  fill-rule="evenodd"/>
          </svg>
        </div>
      </div>
      <markdown
        [data]="item.content"
        class="block max-w-none prose prose-sm prose-h1:my-0 prose-h2:my-0 prose-h3:my-0 prose-h4:my-0 prose-li:m-0 prose-code:text-theme-primary-400 prose-code:before:content-none prose-code:after:content-none prose-p:before:content-none prose-p:after:content-none prose-blockquote:font-light"></markdown>
      <div class="flex">
        <span class="ml-auto text-sm font-normal text-gray-500">{{ item.created | date: "dd.MM.yyyy HH:mm" }} Uhr</span>
      </div>
    </div>
  </div>
</div>
